import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { companyQueryKeys } from "@/company/data/companyQueryKeys";
import { CompanyName } from "@reflag/shared/companyAPI";

function companiesWithNames(
  ids: string[] | undefined,
  data: CompanyName[] | undefined,
  placeholder?: boolean,
) {
  return ids?.map((id) => {
    const prevCompany = data?.find((c) => c.id === id);
    return {
      name: null,
      avatarUrl: null,
      ...prevCompany,
      id,
      isUnknown: prevCompany?.isUnknown ?? (!placeholder && !prevCompany),
    };
  });
}

export function useCompanyNamesData(
  ids?: string[],
  usePlaceholderData = true,
  envIdOverride?: string,
) {
  const { appId, envId: currentEnvId } = useEnvironment();
  const envId = envIdOverride ?? currentEnvId;

  return useQuery({
    queryKey: companyQueryKeys.companyNames(appId, envId, ids),
    queryFn: () =>
      api
        .post<`/apps/:appId/company-names`>(
          `/apps/${appId}/company-names`,
          {
            ids: ids as [string, ...string[]],
          },
          {
            params: { envId: envId! },
          },
        )
        .then((res) => companiesWithNames(ids, res.data, false)),
    enabled: !!appId && !!envId && !!ids?.length,
    placeholderData: usePlaceholderData
      ? (previousData) => companiesWithNames(ids, previousData, true)
      : undefined,
    staleTime: 1000,
  });
}
